module.exports = __webpack_public_path__ + "img/oracle-aconex.f10bc4fb.png";